import React, { Component, useEffect, useState } from 'react';
import Frame from '../images/Frame.svg';
import ContactPopup from './Popup';

function UserConfirmationPopup({popup, data, clearValue, submitForm, events}) {
  const [isOpen, setIsOpen] = useState(popup);
  const distance = events.find(item => item.EventDetailsId === data.EventType)?.RunningDistance;
  useEffect(() => {
    setIsOpen(popup);
  }, [popup]);

  const openPopup = ()=>{
    setIsOpen(true)
  }
  const closeModal = (value)=>{
    clearValue(false);
  }

  return (
    <div>
    {!!isOpen && (<div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 ">
            <div className="relative bg-white rounded shadow-lg w-[90vw] max-w-2xl p-7">
            <h2 className="text-xl">Registration Confirmation !</h2>
              <div className='bg-[#f5f7fb] px-6 py-4 my-4 rounded-lg'>
              <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr] lg:grid-cols-[1fr_1fr] gap-4">
                <p><span className='font-semibold'>Fisrt Name:</span> {data.FirstName} </p>
                <p><span className='font-semibold'>Last Name:</span> {data.LastName} </p>
                <p className="col-span-2"><span className='font-semibold'>Email Address:</span> {data.Emailid} </p>
                <p><span className='font-semibold'>Mobile Number:</span> {data.MobileNo} </p>
                <p><span className='font-semibold'>ID Proof:</span> {data.IdProofType} </p>
                <p><span className='font-semibold'>ID Number:</span> {data.IdProofNumber} </p>
                {/* <p><span className='font-semibold'>Date of Birth:</span> {data.DOB} </p> */}
                <p><span className='font-semibold'>Blood Group:</span> {data.BloodGroup} </p>
                <p><span className='font-semibold'>Running Distance:</span> {distance} </p>
                <p><span className='font-semibold'>T-shirt size:</span> {data.TShirtSize} </p>
              </div>
              </div>
          
            {/* <p className="mb-4 text-center">{message}</p> */}
          <div className="flex justify-end gap-2">
            <button className="bg-yellow-500 text-white py-2 px-4 rounded hover:bg-yellow-600" onClick={()=>submitForm()}>Submit</button>
            <button className="bg-cyan-600 text-white py-2 px-4 rounded hover:bg-cyan-800" onClick={()=>closeModal()}>Close</button>
          </div>
        </div>
      </div>
    )}
    </div>
  )
}

export default UserConfirmationPopup;